module.exports = __webpack_public_path__ + "static/fonts/Fact-Thin.cd3ef24.eot";